import { AiLoaderElement } from './ai-loader.element';

if (!window.customElements.get('ai-loader')) {
    window.customElements.define('ai-loader', AiLoaderElement);
}
